import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import { ProgressSpinner } from "primereact/progressspinner";
import { genElText } from "../../components/utils/EditorDialogElementGenerator";

import { Divider } from "@mui/material";

let editTitle = "";
const addTitle = "Edit Status";

const ChangeStatusEditorDialog = (props) => {
  const {
    visible,
    onHide,
    onConfirm,
    loading,
    title,
    data,
    setData,
    addNewMode,
    error,
    setError,
    jenis_retribusi,
  } = props;

  // dialog state

  /**
   * Validates the form data.
   *
   * @returns {boolean} - Returns true if the data is valid, otherwise false.
   * @returns {object} - Returns an object containing the error messages, format { field: message}.
   */
  if (jenis_retribusi === "status_stnk") {
    editTitle = "STNK";
  } else if (jenis_retribusi === "status_pajak") {
    editTitle = "Pajak";
  } else if (jenis_retribusi === "status_speksi") {
    editTitle = "Speksi";
  }

  const validate = () => {
    let valid = true;
    let newEror = {};

    return valid;
  };

  // handle UI event section

  /**
   * Generate Dialog Form Element
   *
   * various function to generate
   *
   * genElText({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextPassword({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElNumber({ field, name, data, setData, min_fraction_digits, max_fraction_digits, min, max, disabled, autoFocus, error })
   * genElNumberDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElBoolean({ field, name, data, setData, labelTrue = "Ya", labelFalse = "Tidak", disabled, autoFocus, error })
   * genElDate({ field, name, data, setData, primeFormat, min, max, showTime, time, month, year, disabled, autoFocus, error })
   * genElObject({ field, name, value, onClick, selectorGenerator, disabled, autoFocus, error })
   */

  const elNopol = genElText({
    field: "nomor_polisi",
    name: "Nomor Polisi",
    data,
    setData,
    error,
    disabled: true,
  });

  const elJenisMobil = genElText({
    field: "jenis_mobil",
    name: "Jenis Mobil",
    data,
    setData,
    error,
    disabled: true,
  });

  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={props.onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={(e) => {
          onConfirm(data);
          // }
        }}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "28rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={addNewMode ? addTitle : "Edit Status " + editTitle}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
    >
      <div className="col-start-center relative h-100">
        <div className="col-start-start w-80 gap-3">
          {elNopol}
          {elJenisMobil}
        </div>
        <br />
        <Divider layout="horizontal" className="w-[25rem]" />
        <br />
        <div className="col-start-start w-80 gap-3">
          <span className="text-sm font-bold">Status {editTitle}</span>
          <div className="col-start-start gap-4">
            <div className="row-start-start">
              <RadioButton
                inputId="status1"
                name="Status"
                value={0}
                onChange={(e) => {
                  setData({ ...data, [jenis_retribusi]: 0 });
                }}
                checked={data[jenis_retribusi] === 0}
              />
              <label htmlFor="status1" className="ml-2">
                Pending
              </label>
            </div>

            <div className="row-start-start">
              <RadioButton
                inputId="status2"
                name="Status"
                value={1}
                onChange={(e) => {
                  setData({ ...data, [jenis_retribusi]: 1 });
                }}
                checked={data[jenis_retribusi] === 1}
              />
              <label htmlFor="status2" className="ml-2">
                Selesai
              </label>
            </div>

            <div className="row-start-start">
              <RadioButton
                inputId="status3"
                name="Status"
                value={2}
                onChange={(e) => {
                  setData({ ...data, [jenis_retribusi]: 2 });
                }}
                checked={data[jenis_retribusi] === 2}
              />
              <label htmlFor="status3" className="ml-2">
                Diproses
              </label>
            </div>

            <div className="row-start-start">
              <RadioButton
                inputId="status4"
                name="Status"
                value={3}
                onChange={(e) => {
                  setData({ ...data, [jenis_retribusi]: 3 });
                }}
                checked={data[jenis_retribusi] === 3}
              />
              <label htmlFor="status4" className="ml-2">
                Menunggu Surat
              </label>
            </div>

            <div className="row-start-start">
              <RadioButton
                inputId="status5"
                name="Status"
                value={4}
                onChange={(e) => {
                  setData({ ...data, [jenis_retribusi]: 4 });
                }}
                checked={data[jenis_retribusi] === 4}
              />
              <label htmlFor="status5" className="ml-2">
                Menunggu Pelat
              </label>
            </div>
          </div>
        </div>
        {loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-80 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default ChangeStatusEditorDialog;
